// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__1QHAJ","currency":"styles_currency__1IZyC","projectedView":"styles_projectedView__38BYy","pulse":"styles_pulse__2BJLx"};